import { useMutation, useQueryClient } from '@tanstack/react-query'
import { uploadBulkImportCsv } from '../../../api/plan-override-bulk-imports-api'
import type { BulkImportSessionResponseDto } from '../../../api/dto/bulk-import-session.dto'
import { BULK_IMPORT_SESSIONS_QUERY_KEY } from '../../PlanBenefitOverrides/hooks/useBulkImportCsv'

interface BulkImportCsvVariables {
  file: File
}

export function useBulkImportServiceAreaCsv() {
  const queryClient = useQueryClient()

  return useMutation<
    BulkImportSessionResponseDto,
    unknown,
    BulkImportCsvVariables
  >({
    mutationFn: ({ file }) => uploadBulkImportCsv(file, 'service-area'),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [BULK_IMPORT_SESSIONS_QUERY_KEY, 'service-area'],
      })
    },
  })
}
